<template lang="pug">
    div.toggleElement(@click="toggleToFullscreen")
</template>

<script>
    import screenfull from 'screenfull';

    export default {
        methods: {
            toggleToFullscreen() {
                const element = document.getElementById('videoAndChat');
                const videoPlayer = document.getElementById('videoPlayer');

                if (screenfull.isEnabled && !screenfull.isFullscreen) {
                    screenfull.request(element);
                    videoPlayer.classList.add('fullScreenVideo');
                } else {
                    screenfull.exit();
                    videoPlayer.classList.remove('fullScreenVideo');
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .toggleElement
        position: absolute
        width: 35px
        height: 29px
        bottom: 0
        right: 5px
        z-index: 3
        cursor: pointer
</style>
